import { FormValidator } from '~/modules';

export const validationSchema = FormValidator.object().shape({
  CreditSimulationPixKey: FormValidator.string().required(
    'Tem que ser uma conta de sua titularidade',
  ),
});

export type CreditSimulationPixKeyFormValues = Record<
  'CreditSimulationPixKey',
  string
>;

export const initialValues: CreditSimulationPixKeyFormValues = {
  CreditSimulationPixKey: '',
};
